'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'gifts';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f79c';
var svgPathData = 'M192.5 55.09L217.9 36.59C228.6 28.79 243.6 31.16 251.4 41.88C259.2 52.6 256.8 67.61 246.1 75.41L217.8 96H224C245.1 96 263.8 106.2 275.4 121.9C268.1 128.3 261.7 135.8 256.4 144H64C55.16 144 48 151.2 48 160V448C48 456.8 55.16 464 64 464H192V480C192 491.7 195.1 502.6 200.6 512H64C28.65 512 0 483.3 0 448V160C0 124.7 28.65 96 64 96H70.2L41.88 75.41C31.16 67.61 28.79 52.6 36.59 41.88C44.39 31.16 59.4 28.79 70.12 36.59L97.55 56.54L89.23 31.59C85.04 19.01 91.84 5.423 104.4 1.232C116.1-2.96 130.6 3.836 134.8 16.41L144.7 46.17L155.4 15.99C159.8 3.493 173.5-3.048 186 1.377C198.5 5.802 205 19.52 200.6 32.01L192.5 55.09zM344.2 128C366.6 128 387.8 138.4 401.5 156.2L432 195.8L462.5 156.2C476.2 138.4 497.4 128 519.8 128C559.5 128 592 160.1 592 200C592 208.4 590.6 216.5 587.9 224H592C618.5 224 640 245.5 640 272V464C640 490.5 618.5 512 592 512H272C245.5 512 224 490.5 224 464V272C224 245.5 245.5 224 272 224H276.1C273.4 216.5 272 208.4 272 200C272 160.1 304.5 128 344.2 128H344.2zM363.5 185.5C358.9 179.5 351.7 176 344.2 176C330.8 176 320 186.9 320 200C320 213.3 330.7 224 344 224H393.1L363.5 185.5zM272 344H408V272H272V344zM272 464H408V392H272V464zM592 392H456V464H592V392zM456 344H592V272H456V344zM519.8 176C512.3 176 505.1 179.5 500.5 185.5L470.9 224H520C533.3 224 544 213.3 544 200C544 186.9 533.2 176 519.8 176H519.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGifts = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;